// product-countdown.js
(function() {
  function initializeProductCountdowns() {
    // Find all countdown elements in product grid items
    var countdownElements = document.querySelectorAll('[id^="launch-countdown-"]');
    
    countdownElements.forEach(function(countdownEl) {
      var launchDateStr = countdownEl.getAttribute('data-launch-date');
      var launchDate = new Date(launchDateStr);
      var timerSpan = countdownEl.querySelector('[id^="countdown-timer-"]');
      
      if (!timerSpan || isNaN(launchDate.getTime())) return;
      
      var unitLabels = {
        'D': 'd',
        'H': 'h', 
        'M': 'm',
        'S': 's'
      };
      
      // update every second
      var interval = setInterval(update, 1000);
      update();
      
      function update() {
        var now = new Date();
        var diff = launchDate - now;
        
        if (diff <= 0) {
          clearInterval(interval);
          // Hide the countdown and show the normal add to cart button
          var productContainer = countdownEl.closest('.product-grid-item__content');
          if (productContainer) {
            countdownEl.style.display = 'none';
            // Trigger a refresh of the product grid item to show normal button
            var event = new CustomEvent('countdown-expired', { detail: { productId: countdownEl.id.replace('launch-countdown-', '') } });
            document.dispatchEvent(event);
          }
          return;
        }
        
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        var minutes = Math.floor((diff / (1000 * 60)) % 60);
        var seconds = Math.floor((diff / 1000) % 60);
        
        var parts = [];
        if (days > 0) parts.push({ v: days, u: 'D' });
        if (hours > 0) parts.push({ v: hours, u: 'H' });
        if (minutes > 0) parts.push({ v: minutes, u: 'M' });
        parts.push({ v: seconds, u: 'S' });
        
        var htmlContent = parts.map(function(p) {
          var vv = p.v.toString().padStart(2, '0');
          return (
            '<span class="countdown-value">' + vv + '</span>' +
            '<span class="countdown-label">' + unitLabels[p.u] + '</span>'
          );
        }).join(' ');
        
        timerSpan.innerHTML = htmlContent;
        
        // Force display on desktop and hide mobile arrow
        var mobileArrow = countdownEl.querySelector('a[aria-hidden]');
        
        if (window.innerWidth >= 768) {
          timerSpan.style.display = 'inline-block';
          if (mobileArrow) mobileArrow.style.display = 'none';
        } else {
          timerSpan.style.display = 'none';
          if (mobileArrow) mobileArrow.style.display = 'block';
        }
      }
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductCountdowns);
  } else {
    initializeProductCountdowns();
  }
  
  // Also initialize when new content is loaded (for infinite scroll, etc.)
  document.addEventListener('product-grid-updated', initializeProductCountdowns);
})(); 